export const colorCode = {
  scoreColor: {
    scoreBlue: " rgba(26, 35, 126)",
    scoreYellow: "rgba(255, 255, 0)",
    scorePurple: "rgba(128, 0, 128)",
    scoreGrey: "rgba(89, 89, 89)",
  },
  homeFrontColor: {
    lightBlue: "rgb(227, 242, 253)",
  },
  themeColor: {
    primary: "#42a5f5",
  },
};
